<template>
    <div class="Modal" v-if="open" @click.self="close">
        <div class="Modal__content" :style="images_count === 1 ? 'height: unset !important; max-height: 100%' : ''">
            <CloseIcon class="Modal__close" @click="close" />
            <div class="Modal__Content__Images">
                <slot/>
            </div>
        </div>
    </div>
</template>

<script>
import CloseIcon from "@/assets/image/icons/close.svg?inline"

export default {
    name: "Modal",
    //mixins: [scrollBlockBind('open')],
    components: {
        CloseIcon,
    },
    props: {
        open: Boolean,
        images_count: Number,
    },
    methods: {
        close() {
            this.$emit('close');
        }
    },
}
</script>

<style lang="scss">
.Modal {
  z-index: 101;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  display: flex;
  justify-content: center;
  align-items: center;

  background-color: rgba($textLightBlack, 0.2);

  &__content {
    position: relative;
    border-radius: 16px;
    background-color: $white;
    box-shadow: $BlockShadow;
  }

  &__close {
    position: absolute;
    top: 28px;
    right: 28px;
    cursor: pointer;

    @include mobile {
      top: 20px;
      right: 16px;
    }
  }
}

.Modal__Content__Images {
    max-height: 100%;
    overflow-y: scroll;

}
.Modal__Content__Images::-webkit-scrollbar {
    display: none;
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
}
</style>